module.exports = __webpack_public_path__ + "img/wp.dfd35238.png";